<script lang="ts">
  import Button from '$shared/atoms/Button/Button.svelte';
import { ButtonStyle } from '$shared/constants/ButtonStyle';

  interface Props {
    total?: number;
    active?: number;
    onprevious?: () => void;
    onnext?: () => void;
    onclick?: (index: number) => void;
    onfinish?: () => void;
  }

  let { total = 3, active = 1, onprevious, onnext, onclick, onfinish }: Props = $props();

  const onClickPrevious = (): void => {
    onprevious?.();
  };
  const onClickNext = (): void => {
    onnext?.();
  };
  const onClickDot = (index: number): void => {
    onclick?.(index);
  };
  const onClickFinish = (): void => {
    onfinish?.();
  };
</script>

<div class="announcement-nav">
  <div class="sec-left">
    {#if active !== 0}
      <Button style={ButtonStyle.Primary} onclick={onClickPrevious}>Prev update</Button>
    {/if}
  </div>
  <div class="sec-center">
    {#each new Array(total) as item, index}
      <button class="nav-dot" onclick={() => onClickDot(index)} class:active={index === active}
        >{''}</button
      >
    {/each}
  </div>
  <div class="sec-right">
    {#if active !== total - 1}
      <Button style={ButtonStyle.Primary} onclick={onClickNext}>Next update</Button>
    {:else}
      <Button style={ButtonStyle.Primary} onclick={onClickFinish}>Done</Button>
    {/if}
  </div>
</div>

<style>
  .announcement-nav {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 24px;
  }
  .announcement-nav div {
    justify-self: center;
    align-self: center;
  }
  .announcement-nav div:first-child {
    justify-self: left;
  }
  .announcement-nav div:last-child {
    justify-self: right;
  }

  .nav-dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    background-color: var(--grey-xlight);
    border-radius: 50%;
  }
  .nav-dot.active {
    background-color: var(--green);
  }
  .nav-dot:not(:last-child) {
    margin-right: 8px;
  }
</style>
